var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.group)?_c('TransitionGroup',_vm._g(_vm._b({staticClass:"transition-group",attrs:{"name":_vm.name}},'TransitionGroup',_vm.$attrs,false),_vm.$listeners),[_vm._t("default")],2):_c('Transition',_vm._g(_vm._b({attrs:{"name":_vm.name}},'Transition',_vm.$attrs,false),_vm.$listeners),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }